import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import OrderHistoryTiles from './OrderHistoryTiles'
import axios from 'axios'
import { Url } from '../services/Constants'
import { setHeader } from '../services/Headers'


export default function OrderHistory({feedHandle, orderData}) {

  const [orderHistory, setOrderHistory] = useState([])



  useEffect(()=>{
    const getOrderHistory =async()=>{
    try {
      const result = await axios(`${Url}/buyer/orders?isLatest=true`,setHeader())
      if(result.data.response_code===200){
        setOrderHistory(result.data.response_data.orders)
      }else{
          setOrderHistory([])
      }
    } catch (error) {
      console.log(error)
    }
  }


  getOrderHistory()
  },[])

  useEffect(()=>{},[orderHistory])




  const feedHandle1 = (data)=>{
      feedHandle(data)
  }

  const orderData1 = (data)=>{
    orderData(data)
  }


  return (
    <div className="Checkout-feed bg-red-50 min-h-screen w-full rounded-lg mb-5 shadow-md max-sm:w-[90%] max-sm:mx-auto max-sm:mb-20">
    <div className="feed-container w-[96%] py-5 mx-auto">
      {orderHistory.length > 0 ? (
        orderHistory.map((item) => (
          <OrderHistoryTiles key={item.order_product_id} data={item} feedHandle1={feedHandle1} orderData1={orderData1} />
        ))
      ) : (
        <div className="no-orders text-center text-2xl text-gray-500">
          No orders found
        </div>
      )}


    </div>
    </div>
  )
}
